import React from 'react';
import Icon from '../../../components/AppIcon';

const OfflineIndicator = ({ isOffline, pendingSyncs }) => {
  if (!isOffline && pendingSyncs === 0) return null;

  return (
    <div className={`fixed top-20 left-4 right-4 z-50 ${isOffline ? 'bg-warning' : 'bg-accent'} text-white rounded-lg p-3 shadow-lg`}>
      <div className="flex items-center">
        <Icon 
          name={isOffline ? "WifiOff" : "Upload"} 
          size={16} 
          className="mr-2 flex-shrink-0" 
        />
        <div className="flex-1 min-w-0">
          {isOffline ? (
            <div>
              <p className="text-sm font-medium">Offline-Modus</p>
              <p className="text-xs opacity-90">
                Gescannte VINs werden lokal gespeichert
              </p>
            </div>
          ) : (
            <div>
              <p className="text-sm font-medium">Synchronisierung läuft</p>
              <p className="text-xs opacity-90">
                {pendingSyncs} VIN{pendingSyncs !== 1 ? 's' : ''} werden hochgeladen
              </p>
            </div>
          )}
        </div>
        
        {!isOffline && pendingSyncs > 0 && (
          <div className="ml-2">
            <div className="animate-spin rounded-full h-4 w-4 border-2 border-white border-t-transparent"></div>
          </div>
        )}
      </div>
    </div>
  );
};

export default OfflineIndicator;